// extracted by mini-css-extract-plugin
export default {"addressContainer":"Detail__addressContainer___1Tsk9","section":"Detail__section___36LDo","certificates":"Detail__certificates___KXxiH","sections":"Detail__sections___Tj6J0"};